import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../components/breadcrumb/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import { CRO_ENQUIRY_TABLE_HEAD } from "../../../components/datagrid/CRM/CroEnquiries/CroEnquiriesTableHead";
import { useDispatch, useSelector } from "react-redux";
import { getFoundationPendingEnquiries } from "../../../redux/features/croSlice";
import CustomGridToolbar from "../../../components/datagrid/GridToolBar";

const CroEnquiriesFoundationProgramsPending = () => {
    const profile = useSelector((state) => state.login.data.profile);
    const { croEnquiriesFoundation, loading } = useSelector(
        (state) => state.cro
    );
    const dispatch = useDispatch();

    const [gridSize, setGridSize] = useState(5);
    const [croId, setCroId] = useState(
        profile.roleID === 10 ? profile.userId : ""
    );

    useEffect(() => {
        dispatch(getFoundationPendingEnquiries(croId));
    }, []);
    return (
        <Box>
            <Box
                sx={{
                    mb: 2,
                }}
            >
                <Typography variant="h4">
                    Cro Enquiries Pending Foundation Programmes
                </Typography>
                <Breadcrumb />
            </Box>

            <DataGrid
                loading={loading}
                rows={croEnquiriesFoundation}
                columns={CRO_ENQUIRY_TABLE_HEAD}
                getRowId={(row) => row.serialNumber}
                pageSize={gridSize}
                onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
                rowsPerPageOptions={[5, 10, 25, 50]}
                components={{ Toolbar: CustomGridToolbar }}
                autoHeight
            />
        </Box>
    );
};

export default CroEnquiriesFoundationProgramsPending;
